import Vue from 'vue'
import VueRouter from "vue-router";

import Viewer from "./components/Viewer";
import Start from "./components/Start";

Vue.use(VueRouter);

let router = new VueRouter({
  mode: 'history',
  routes: [
    {path: '/', component: Viewer},
    {path: '/start', component: Start},
  ]
});

new Vue({
  router,
  el: '#app'
});



// WEBPACK FOOTER //
// ./src/main.js